import {
  HttpErrorKind,
  HttpErrorResponse,
  HttpErrorConstructor,
} from './types';

export const HttpError: HttpErrorConstructor = class extends Error {
  name = 'HttpError';

  kind: HttpErrorKind;

  response?: HttpErrorResponse;

  constructor(kind: HttpErrorKind) {
    super(`[type="${kind}"]`);
    this.kind = kind;
  }

  /**
   * @deprecated
   */
  getMessage = () => {
    if (this.response) {
      const messages = this.response.result?.messages || [];
      return messages.length > 0 ? messages[0] : '';
    }

    return this.message;
  };
};
